<template>
  <div>
    <div class="title">阈值类型:</div>
    <div class="radio1">
      <el-radio v-model="radio" label="automatic">智能阈值</el-radio>
    </div>
    <div class="radio2">
      <el-radio v-model="radio" label="custom">自定义阈值</el-radio>
    </div>
    <div v-if="radio==='custom'">
      <el-select class="select" v-model="option" placeholder="请选择">
        <el-option
          v-for="item in options"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        ></el-option>
      </el-select>
      <span class="word">超过</span>
      <div class="input">
        <el-input v-model="input" placeholder="0~100的整数"></el-input>
      </div>
      <span class="word">时告警</span>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      options: [
        {
          value: 'index',
          label: '负面舆情指数'
        },
        {
          value: 'count',
          label: '负面新闻条数'
        }
      ],
      option: 'index',
      radio: 'automatic',
      input: 10
    };
  },
  props: {
    radioData: {
      type: String
    },
    optionData: {
      type: String
    },
    inputData: {
      type: Number
    }
  },
  watch: {
    radioData(val) {
      this.radio = val;
    },
    optionData(val) {
      this.option = val;
    },
    inputData(val) {
      this.input = val;
    },
    radio(val) {
      this.$emit('radioChange', val);
    },
    option(val) {
      this.$emit('optionChange', val);
    },
    input(val) {
      this.$emit('inputChange', Number(val));
    }
  },
  mounted() {
    this.radio = this.radioData;
    this.option = this.optionData;
    this.input = this.inputData;
  }
};
</script>

<style lang="scss" scoped>
.title {
  padding-bottom: 16px;
  font-size: 14px;
  color: #ffffff;
}
.radio1 {
  margin-left: 32px;
  margin-bottom: 16px;
  .el-radio {
    color: #ffffff;
  }
}
.radio2 {
  margin-left: 32px;
  margin-bottom: 16px;
  .el-radio {
    color: #ffffff;
  }
}
.select {
  margin-left: 54px;
}
.word {
  margin: 0 8px;
  color: rgba(255, 255, 255, 0.8);
  font-size: 14px;
}
.input {
  display: inline-block;
  width: 146px;
}
/deep/.el-radio .el-radio__input.is-checked + .el-radio__label {
  color: #ffffff;
}
/deep/.el-radio .el-radio__input .el-radio__inner {
  width: 12px;
  height: 12px;
  border: solid 1px rgba(255, 255, 255, 0.6);
  background-color: transparent;
}
/deep/.el-radio .el-radio__input.is-checked .el-radio__inner {
  border: solid 1px #45a8cc;
}
/deep/.el-radio .el-radio__input.is-checked .el-radio__inner::after {
  width: 6px;
  height: 6px;
  background-color: #45a8cc;
}
/deep/.el-input .el-input__inner {
  height: 36px;
  border: none;
  color: #ffffff;
  background-color: #27252a;
}
/deep/.el-select .el-input__inner {
  height: 36px;
  border: none;
  color: #ffffff;
  background-color: #3b3a3f !important;
}
</style>


